export const DEFAULT_PLATFORMS = [
  "888Poker",
  "ACR",
  "Bodog",
  "CoinPoker",
  "GG Poker",
  "KK Poker",
  "Outros",
  "Party Poker",
  "PokerStars",
  "PP Poker",
  "Suprema",
  "WPT",
  "Ya Poker",
];

export const normalizePlatformName = (platform) => String(platform || "").trim();

export const getKnownPlatforms = (...sources) => {
  const platforms = new Set(DEFAULT_PLATFORMS);

  sources.flat().forEach((item) => {
    const platform =
      typeof item === "string" ? item : item?.plataforma || item?.platform;
    const normalized = normalizePlatformName(platform);
    if (normalized) platforms.add(normalized);
  });

  return [...platforms].sort((a, b) => a.localeCompare(b, "pt-BR"));
};
